import { sessaoFetch } from '@/service/fetch'

export async function getCidadesSelect () {
  return sessaoFetch(`base`, '/cidade', 'GET')
}
export async function getCidadesFiltro (cidade) {
  return sessaoFetch(`base`, `/cidade?nome=${cidade}&all=1`, 'GET')
}



// WEBPACK FOOTER //
// ./src/api/cidades.js